import { Entity, EntityConfiguration, Schema } from '@technocom/data/core';

export class Action extends Entity<ActionDTO, number> {
  static readonly options: EntityConfiguration = Entity.extendOptions({
    title: 'Путеводитель мигранта',
    serverUrl: '/helper',
  });

  static readonly schema: Schema = Entity.extend<ActionDTO>({
    fields: {
      id: {
        type: Number,
        title: 'ID',
      },
      needDate: {
        type: Date,
        title: 'Дата, до которой нужно выполнить',
      },
      needGet: {
        type: String,
        title: 'Что нужно получить',
      },
      needDo: {
        type: String,
        title: 'Что нужно сделать',
      },
      check: {
        type: Boolean,
        title: 'TRUE если пункт исполнен',
      },
      checkDate: {
        type: Date,
        title: 'Дата исполнения',
      },
    },
  });
}

export interface ActionDTO {
  id: number;
  needDate: Date;
  needGet: string;
  needDo: string;
  check: boolean;
  checkDate: Date;
}
